var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".z,.y{fill:#fff;}.z{stroke:#707070;opacity:0;}.x{stroke:none;}.w{fill:none;}\n"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "z"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "w",
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 10)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M18.276,21.167a.839.839,0,0,1-.845.833H11.256a.833.833,0,1,1,0-1.667h6.176A.839.839,0,0,1,18.276,21.167Zm.845-5.277H9.567a.833.833,0,1,0,0,1.667h9.554a.833.833,0,1,0,0-1.667Zm1.689-4.445H7.878a.833.833,0,1,0,0,1.667H20.81a.833.833,0,1,0,0-1.667ZM22.5,7H6.189a.833.833,0,1,0,0,1.667H22.5A.833.833,0,1,0,22.5,7Z",
    transform: "translate(-5.344 -7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.db69b2050f6551e87299daa039db310a.svg";
export { ForwardRef as ReactComponent };